import React from 'react';
import { IconName, Button, ButtonProps, Icon } from '@economic/taco';

export interface DrilldownButtonProps {
    header: React.JSX.Element | string;
    description: React.JSX.Element | string;
    icon?: IconName;
    showNextIcon?: boolean;
}

export function DrilldownButton({
    icon,
    header,
    description,
    showNextIcon = false,
    ...buttonProps
}: DrilldownButtonProps & Omit<ButtonProps, 'children'>) {
    return (
        <Button
            appearance="ghost"
            fluid
            className="p-3 gap-2 border-grey-300 hover:border-grey-500 !hover:bg-grey-100"
            {...buttonProps}>
            <div className="bg-blue-lightest rounded text-1xl p-2">{icon ? <Icon name={icon} /> : null}</div>
            <div className="flex flex-col text-left">
                <h5 className="text-black">{header}</h5>
                <p className="m-0 text-grey-700">{description}</p>
            </div>
            {showNextIcon ? <Icon name="chevron-right" className="!ml-auto" /> : <div className="ml-auto" />}
        </Button>
    );
}
